import { render, staticRenderFns } from "./ConfirmationPage.vue?vue&type=template&id=3db6eb85&scoped=true"
import script from "./ConfirmationPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationPage.vue?vue&type=style&index=0&id=3db6eb85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6eb85",
  null
  
)

export default component.exports